import { PagenatedResponse } from '@models/common';
import { GetProgramSchedule, ProgramSchedule, ProgramScheduleSearchQuery } from '@models/program-schedule';
import { apiClient } from '.';

export const searchProgramSchedules = async (query?: ProgramScheduleSearchQuery) => {
  return apiClient.get<PagenatedResponse<GetProgramSchedule>>(`/admin/v1/program-schedules`, {
    params: query,
  });
};

export const exportProgramSchedules = async (query?: ProgramScheduleSearchQuery) => {
  return apiClient.get<PagenatedResponse<ProgramSchedule>>(`/admin/v1/program-schedules/export`, {
    params: query,
    responseType: 'blob',
    headers: { 'Cache-Control': 'no-cache' },
  });
};

export const getProgramSchedulesCountByOptionName = async (query?: ProgramScheduleSearchQuery) => {
  return apiClient.get<
    { _id: { optionName: string; productName: string; partnerId: string; partnerName: string }; count: number }[]
  >(`/admin/v1/program-schedules/counts`, {
    params: query,
  });
};

export const getProgramSchedule = async (id: string) => {
  return apiClient.get<ProgramSchedule>(`/admin/v1/program-schedules/${id}`);
};

export const createProgramSchedule = async (body: Partial<ProgramSchedule>) => {
  return apiClient.post<ProgramSchedule>(`/admin/v1/program-schedules`, body);
};

export const updateProgramSchedule = async (id: string, body: Partial<ProgramSchedule>) => {
  return apiClient.put<ProgramSchedule>(`/admin/v1/program-schedules/${id}`, body);
};
